export default __webpack_public_path__ + "static/media/S-035.5f8fa63c.png";